import store from "../../context/store/store";
import {
   contacts, contactSync,
  contactwindowDetails,
  teamAPIreq, UserDetails
} from "../../models/model";
import _ from 'lodash';
//import socketIOClient from "socket.io-client";
import { chats, chatwindowDetails } from "../../models/model";

import { config } from '../constant';
import { compareName, Cookie } from "../utils";
import { actionTypes, Types } from "../../context/action/action";
import { ChatService } from "../chatService";
import { determineIps, toastInformation } from "../callService/common";
import { storeTranslatedLanguage } from "../callService/common";
import { eventService } from "../eventService/event.service";
import { generateChatID, loadScreen, userInfo } from "../socketChatService/utils";
import { chatSideWindow } from "../eventService/eventApiService";
import {chatSDK} from 'unifiedring-sdk'
import { SocketChatService } from "../socketChatService";
import { uuidv4 } from "../meetingService/utils/meetingServices";
import { createCallConnection } from "../callService/callService";
let socket: any;
export class contactService {
  public static async getWorkcontact(req: contactSync) {
    new chatSDK.ChatRestService().getWorkContactV2().then(async (response:any)=>{
   let userstatus: any = store.getState().contactWindowReducer.presenceUserStatus || [];
      contactService.getTeamContact();
      let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
      let token_loggedUserDetails: any = store.getState().loginReducer.token || [];
      if(token_loggedUserDetails.length===0){
        const service = new SocketChatService(loggedUserDetails?.sip_login_id, loggedUserDetails?.domain_id);
        const queryParams:contactSync = { ext: loggedUserDetails.ext, CallId: uuidv4()};
        let ipDetails:any= await determineIps();
        if(ipDetails?.IP){
       createCallConnection(loggedUserDetails,ipDetails.IP);
        }
      }
      let objectList:any = [];
    

      
      //console.log(token_loggedUserDetails,"token_loggedUserDetails")
      if(token_loggedUserDetails===''){
       
        const service = new SocketChatService(loggedUserDetails?.sip_login_id, loggedUserDetails?.domain_id);
        const queryParams:contactSync = { ext: loggedUserDetails.ext, CallId: uuidv4()};

        let ipDetails:any=  determineIps();
       createCallConnection(loggedUserDetails,ipDetails.IP);
      }
      if(response?.statusCode===200 && response?.companyContacts){
        const companyContacts = response?.companyContacts;
        if(Array.isArray(companyContacts) && companyContacts.length>0){
                objectList = [...companyContacts, loggedUserDetails].reduce((acc: any, curr: any) => {
          //const participant: any = userstatus[curr.sip_login_id];
          curr['user_status'] = 'Invisible'
          if (curr?.caller_id && curr["sip_login_id"]) {
            return (acc[curr["sip_login_id"]] = curr, acc);
          } else {
            return null;
          }
        }, {});
        for (const prop in userstatus) {
          if (userstatus[prop]?.connectionStatus === 0) {
            if (_.isUndefined(objectList?.[prop]) === false) {
              objectList[prop].user_status = "Invisible";
            }
          } else {
            if (userstatus[prop]?.connectionStatus === 1) {
            if (_.isUndefined(objectList?.[prop])===false) {
              objectList[prop].user_status = "Available";
            }
          }
        }
      }
        
        store.dispatch({
          type: Types.WORK_CONTACT_GET,
          payload: {
            workContactsnew: objectList
          }
        });
        contactService.mergeSocketContacts(objectList);
        let self = this;
      self?.mergeContacs(companyContacts);
      store.dispatch({
        type: Types.WORK_CONTACT,
        payload: {
          workContacts: companyContacts
        }
      });
        }
        
      }
    })
  }

  public static addEventListener() {


    // socket.on("call_list_update", (contactlist: any) => {
    //   console.log("call_list_update", contactlist);
    // });

    /*  socket.on("contact_list", (contactlist:any) => {
       console.log("contact_sync >>>>>>>>>", contactlist);
       this.mergeContacs(contactlist);
       store.dispatch({
         type: Types.WORK_CONTACT,
         payload: { workContacts:contactlist }
       });
     }); */


    socket.on("translateTranscript", (updatedLanguage: any) => {
      storeTranslatedLanguage(updatedLanguage);
    });

    socket.on("new_voicemail", (response:any) => {
  
    });

    socket.on("new_callRecording ", (response:any) => {

    });

  }

  public static rec_voicemailCount() {
    if (socket) {
      socket.emit("getVoicemailCount");
      socket.emit("getCallRecordingCount");
    }
  }


  public static updateCallListSoc() {
    socket.emit("call_list_update");
  }

  public static getlanTranslation(trans: object) {
    if (socket) {
      socket.emit("translateTranscript", trans);
    }
  };

  // need to remove this method once we get the listy from wss
  public static async getCompanycontact() {
    if (socket) {
      socket.emit("get_contact_list", {});
      // socket.on("contact_list", (contactlist: any) => {
      //   store.dispatch({
      //     type: Types.WORK_CONTACT,
      //     payload: {
      //       workContacts: contactlist
      //     }
      //   });
      // });
    }
  };

  public static async mergeContacs(workcontacts: any) {

    let { teamContacs, isTeamContactLoading }: any = store.getState().contactReducer;
    let self = this;
    if (!isTeamContactLoading) {
      setTimeout(() => {
        self?.mergeContacs(workcontacts);
      }, 2000);
      return true;
    }


    let bundleArray: any = [];
    if (teamContacs.length > 0) {
      if (workcontacts.length > 0) {
        bundleArray = teamContacs.concat(workcontacts);
      } else {
        bundleArray = teamContacs;
      }
      bundleArray = bundleArray.sort(compareName);
    } else {
      bundleArray = workcontacts.sort(compareName);
    }

    store.dispatch({
      type: Types.ALL_CONTACT,
      payload: {
        allContacs: bundleArray
      }
    });

  }
  public static async mergeSocketContacts(workcontacts: any) {
    let { teamContacsnew }: any = store.getState().contactReducer;
    let workContactValues: any = workcontacts?Object.values(workcontacts):[];
    let teamContactsValues: any = teamContacsnew?Object.values(teamContacsnew):[];
    let bundleArray: any = [];
    
    if (teamContactsValues.length > 0) {
      if (workContactValues.length > 0) {
        bundleArray = workContactValues.concat(teamContactsValues);
      }
      else {
        bundleArray = teamContactsValues;
      }
      bundleArray = bundleArray.sort(compareName);
    } else {
      bundleArray = workContactValues.sort(compareName);
    }

    store.dispatch({
      type: Types.ALL_CONTACT_NEW,
      payload: {
        allContactsNew: bundleArray
      }
    });
  }

  public static async getTeamContact(team_id: any = "0") {
    const token: any = Cookie.get();
    let tokenData: any = token["ssoToken"];

    let teamInputDetails: teamAPIreq = {

      team_id: team_id,
      token: tokenData,
      baseUrl: config().CHAT_RESTAPI_URL
    };
   
    new chatSDK.ChatRestService().getTeamInfo(teamInputDetails).then((response: any) => {
      if (response?.statusCode === 200) {

        if (team_id === "0") {
          response?.result.sort(compareName);
          store.dispatch({
            type: Types.TEAM_CONTACT,
            payload: {
              teamContacs: response.result,
              isTeamContactLoading: true
            }
          });
          const objectList = response.result.reduce((acc: any, curr: any) => {
            if (curr?.team_id) {
              return (acc["con" + curr["team_id"]] = curr, acc);
            } else {
              return null;
            }
          }, {});
          store.dispatch({
            type: Types.TEAM_CONTACT_NEW,
            payload: {
              teamContacsnew: objectList,
              isTeamContactLoading: true
            }
          });
          store.dispatch({
            type: Types.ALL_CONTACT_LOADING,
            payload: {
              allContacsLoading: true
            }
          });
       
            loadScreen(false);
       
        } else {
          let { teamContacs, allContacs }: any = store.getState().contactReducer;

          let tindex: number = _.findIndex(teamContacs, { team_id: parseInt(team_id.slice(3)) });

          let aindex: number = _.findIndex(allContacs, { team_id: parseInt(team_id.slice(3)) });

          if (tindex !== -1) {

            teamContacs[tindex] = response?.result[0];

            if (aindex !== -1) {
              allContacs[aindex] = response?.result[0];
            }

          } else {
            teamContacs.push(response?.result[0]);
            allContacs.push(response?.result[0]);
            teamContacs.sort(compareName);
            allContacs.sort(compareName);
          }



          store.dispatch({
            type: Types.TEAM_CONTACT,
            payload: {
              teamContacs: teamContacs,
              isTeamContactLoading: true
            }
          });
          store.dispatch({
            type: Types.ALL_CONTACT_LOADING,
            payload: {
              allContacsLoading: true
            }
          });


          store.dispatch({
            type: Types.ALL_CONTACT,
            payload: {
              allContacs: allContacs
            }
          });

        }

      }

    });



  }

  public static async scrollContactWindow(contactDetails: any,index:any) {

    store.dispatch({
      type: Types.SCROLL_CONTACT_LINK_LIST,
      payload: {
        scrollContactLinkList: contactDetails
      }
    });
  }



  public static async openContactWindow(contactDetails: any,index:any) {

    store.dispatch({
      type: Types.CONTACT_LINK_LIST,
      payload: {
        contactLinkList: []
      }
    });
 
    store.dispatch({
      type: Types.CONTACT_SAVED_LIST,
      payload: {
        contactSavedChatList: []
      }
    });
    store.dispatch({
      type: Types.TAB_CONTENT_DETAILS,
      payloads: {
        tabcontactDetail: contactDetails,
        tabcontact: contactDetails,
        tabrecentindex: index
      }
    });

    let { xmppDetails }: chats = store.getState().chatReducer;

    let { conference, id } = xmppDetails;

    let w_jid: any = contactDetails?.jid;

    if (contactDetails&& contactDetails?.team_id) {
      let { workContactsnew }: contacts = store.getState().contactReducer;
      let teamID: string = `${contactDetails?.team_id_prefix}${contactDetails?.team_id}@${conference}`;
      let members: any = contactDetails?.team_members && contactDetails?.team_members.split(',');
      let particularTeamMembrDetails =Array.isArray(members)&& members.length>0&& members.map((contactdata: any) => {
        let parsedVal: any = parseInt(contactdata.trim())
        let chatUser: any = workContactsnew[parsedVal];

        return chatUser !== undefined ? chatUser : {};
      });
   
      contactDetails.teammembersdetails = particularTeamMembrDetails;

      contactDetails.jid = teamID;

      contactDetails.caller_id = contactDetails.team_name;

    }
   
    let chatId: any = contactDetails?.sip_login_id ?
      generateChatID(userInfo().fromID, contactDetails?.sip_login_id?.toString()) : contactDetails?.team_id?.toString();

     if (w_jid === id && contactDetails){
      contactDetails.isMyspace = true;
    } else  {
      contactDetails.isMyspace = false
    }

    contactDetails.chatId = chatId;
    store.dispatch({
      type: Types.OPEN_CONTACT_WINDOW,
      payload: {
        isContactWindow: true,
        contactWindowDetails: contactDetails,
        isMySpace: false

      }
    });
    store.dispatch({
      type: Types.CONTACT_FILES_LIST,
      payload: {
        isContactFile: false,
        contactFileList: []
      }
    });

  };

  public static async taskList() {
    let { contactWindowDetails }: contactwindowDetails = store.getState().contactWindowReducer;
    let { chatWindowDetails, isMySpace }: chatwindowDetails = store.getState().chatWindowReducer;
    let sipId;
    let type;

    if (isMySpace && window.location.pathname === "/chats") {
      sipId = chatWindowDetails.sip_login_id;
      type = 3
    } else {
      sipId = (contactWindowDetails?.team_id || contactWindowDetails?.team_id_prefix ?
        contactWindowDetails?.team_id
        : contactWindowDetails?.sip_login_id);
        type = contactWindowDetails?.team_id || contactWindowDetails?.team_id_prefix ? 2 :1
    }

    return new eventService().getTasklist(sipId,type).then((data: any) => {
      store.dispatch({
        type: Types.GET_TASK_LIST,
        payload: {
          isTask: true,
          taskLoader: false,
          taskListDetails: data.result,
          taskDefaultCount: data.total_count
        }
      });
      return data;
    }).catch(() => {

    });
  };

  public static uploadProPic: any = (base64: any, url: any) => {
  }

  public static async eventList() {
    let { contactWindowDetails }: contactwindowDetails = store.getState().contactWindowReducer;
    let { chatWindowDetails, isMySpace }: chatwindowDetails = store.getState().chatWindowReducer;

    let sipId;
    let type;
    if (isMySpace && window.location.pathname === "/chats") {
      sipId = chatWindowDetails.sip_login_id;
      type = 3
    } else {
      sipId = (contactWindowDetails?.team_id || contactWindowDetails?.team_id_prefix ?
        contactWindowDetails?.team_id
        : contactWindowDetails.sip_login_id);
        type = contactWindowDetails?.team_id || contactWindowDetails?.team_id_prefix ? 2 :1
    }
    return new eventService().getEventlist(sipId,type).then((data: any) => {
      store.dispatch({
        type: Types.GET_EVENT_LIST,
        payload: {
          isEvent: true,
          eventLoader: false,
          eventListDetails: data.result
        }
      });
      return data;
    }).catch(() => {

    });
  };



  public static async notesList() {
    let { contactWindowDetails }: contactwindowDetails = store.getState().contactWindowReducer;
    let { chatWindowDetails, isMySpace }: chatwindowDetails = store.getState().chatWindowReducer;

    let sipId;
    let type;
    if (isMySpace && window.location.pathname === "/chats") {
      sipId = chatWindowDetails.sip_login_id;
      type = 3
    } else {
      sipId = (contactWindowDetails?.team_id || contactWindowDetails?.team_id_prefix ?
        contactWindowDetails?.team_id
        : contactWindowDetails?.sip_login_id);
        type = contactWindowDetails?.team_id || contactWindowDetails?.team_id_prefix ? 2 :1
    }
    return new eventService().getNotelist(sipId,type).then((data: any) => {
      store.dispatch({
        type: Types.GET_NOTES_LIST,
        payload: {
          isNotes: true,
          notesListDetails: data.result,
          notesDefaultCount: data.total_count
        }
      });
      return data;
    }).catch(() => {

    });

  };



  public static async editContactNote(formData: any, uid: any, key:any) {
    let loginUser: any = store.getState().loginReducer.userdetails;
    let chat_reducer: chats = store.getState().chatReducer;
    let { chatWindowDetails,isMySpace }: any = store.getState().chatWindowReducer;
    let { contactWindowDetails }: any = store.getState().contactWindowReducer;
    let contactDetails: any = key === "login" ? loginUser : key === "chats" ? chatWindowDetails : contactWindowDetails;

    let data: any = {
      summary: formData.title,
      description: formData.description,
      sender: formData.sender,
      receiver: formData.receiver,
      groupId: contactDetails &&
        'team_id' in contactDetails ? contactDetails?.team_id : "",
      ownerId: formData.owner_id,
      threadId: "",
      domainId: loginUser.domain_id,
      replaceId: formData.replace_id
    };
    new eventService().editNote(uid, data)
      .then((res: any) => {
        isMySpace? chat_reducer.isWindowSlide && ChatService.rightSideToogle():  chatSideWindow(true,"notelist",{});

        store.dispatch({
          type: Types.CONTACT_NOTE_UPDATE,
          payload: {
            isNoteUpdate: true
          }
        });
        toastInformation(config().NOTEUPDATE, 'success');
      }).catch((error: any) => {
        console.log(error, 'error');
      });
  }

  public static async createContactNote(formData: any, key:any) {

    let loginUser: any = store.getState().loginReducer.userdetails;
    let chat_reducer: chats = store.getState().chatReducer;
    let { chatWindowDetails,isMySpace }: any = store.getState().chatWindowReducer;
    let { contactWindowDetails }: any = store.getState().contactWindowReducer;
    let contactDetails: any = key === "login" ? loginUser : key === "chats" ? chatWindowDetails : contactWindowDetails;
    let data: any = {
      summary: formData.title.length>0 ?formData.title:"Untitled",
      description: formData.description,
      sender: loginUser.sip_login_id,
      receiver: Object.keys(contactDetails).length > 0 ? 'team_id' in contactDetails ?
        contactDetails?.team_id :
        contactDetails?.sip_login_id?.toString() : loginUser.sip_login_id,
      groupId: contactDetails &&
        'team_id' in contactDetails ? contactDetails?.team_id : "",
      ownerId: loginUser.sip_login_id,
      threadId: "",
      domainId: loginUser.domain_id
    };

    return new eventService().createNote(data)
      .then((res: any) => {
        if (res.statusCode === 200) {
          if( key !== "login"){
            isMySpace? chat_reducer.isWindowSlide && ChatService.rightSideToogle():   chatSideWindow(true,"notelist",{});
          }
          store.dispatch({
            type: Types.CONTACT_NOTE_UPDATE,
            payload: {
              isNoteUpdate: true
            }
          });
         
          toastInformation(config().NOTESUCCESS, 'success');
          contactService.notesViewToast(true, res, formData?.key);

        }

      }).catch((error: any) => {

        console.log(error, 'error');

      });

  }

  public static async deleteContactNote(data: any) {
    let loginUser: any = store.getState().loginReducer.userdetails;
    let Notedata = {
      uid: data.uid,
      domainId: loginUser.domain_id
    };
    return new eventService().deleteNote(Notedata)
      .then((res: any) => {
        if (res.statusCode === 200) {
          store.dispatch({
            type: Types.CONTACT_NOTE_UPDATE,
            payload: {
              isNoteUpdate: true
            }
          });
          toastInformation(config().NOTEDELETE, 'success');
        }

      }).catch((error: any) => {
        console.log(error, 'error');

      });

  }



  // public static async createNote(input: any) {

  //   let { token }: LoginState = store.getState().loginReducer;

  //   let teamInputDetails: any = {

  //     data: input,
  //     token: token,
  //     baseUrl: config().CHAT_RESTAPI_URL
  //   };


  //   return new Promise((resolve, reject) => {


  //     restAPIChat.createNote(teamInputDetails).then((response: any) => {

  //       if (response.statusCode === 200) {
  //         ChatService.notesList("all");
  //         toastInformation(config().NOTESUCCESS, 'success');
  //       }

  //       resolve(response);

  //     });
  //   });

  // }

  public static async saveContactDispatch(contactSavedChatList: any) {

    store.dispatch({
      type: Types.CONTACT_SAVED_LIST,
      payload: {
        contactSavedChatList: contactSavedChatList
      }
    });
  }

  public static async linkContactDispatch(contactLinkList: any) {

    store.dispatch({
      type: Types.CONTACT_LINK_LIST,
      payload: {
        contactLinkList: contactLinkList
      }
    });
  }
  // public static async getFilesList(id: any,limit:any,offset:any) {

  //   let { contactWindowDetails}:contactwindowDetails = store.getState().contactWindowReducer;

  //   let data = contactWindowDetails ? contactWindowDetails : "";
  //   let team_id :any;
  //   if(data.team_id)
  //   {
  //     team_id  = data.team_id_prefix + data.team_id;
  //   }
  //   if (id === team_id){

  //     XMPP.getFileLinksSaveMessages({
  //       offset: offset, limit: limit, action: "get_details_for_group",
  //       details_for_group: "files", peer_id: id
  //     });
  //   }

  //   else{
  //     XMPP.getFileLinksSaveMessages({
  //       offset: 0, limit: limit,  action: "get_details_for_user",
  //       details_for_user: "files", peer_id: id && id.toString()
  //     });
  //   }


  // };
  public static async clearforContact() {
    store.dispatch({
      type: Types.CONTACT_FILES_LIST,
      payload: {
        isContactFile: false,
        contactFileList: []
      }
    });
    store.dispatch({
      type: Types.CHAT_FILE_LOAD,
      payload: {
        ischatfileLoad: false,
        contactfileLength: 0,
        ischatfileStopPagination: true
      }
    });
    store.dispatch({
      type: Types.CONTACT_FILE_LOAD,
      payload: {
        isfileLoad: false,
        contactfileLength: 0,
        isfileStopPagination: true
      }
    });
    store.dispatch({
      type: Types.GET_FILES_LIST,
      payload: {
        isfile: false,
        fileListDetails: []
      }
    });
    store.dispatch({
      type: Types.OPEN_CONTACT_WINDOW,
      payload: {
        isContactWindow: false,
        contactWindowDetails: {},
        isMySpace: false

      }
    });
  }
  public static async clearRecentchat() {
    store.dispatch({
      type: actionTypes.UPDATE_ARCHIVEID,
      payload: {
          archiveID: "",
          scrollPos: -1
      }
  });
  }
  // public static async filesPagination(id: any,limit:any,offset:any){

  //   let { contactWindowDetails, contactfileLength,
  //     isfileStopPagination}:contactwindowDetails = store.getState().contactWindowReducer;
  //   let {chatWindowDetails,isMySpace}:chatwindowDetails = store.getState().chatWindowReducer;
  //   let data = contactWindowDetails ? contactWindowDetails : "";
  //   let team_id :any;
  //   if(data.team_id)
  //   {
  //     team_id  = data.team_id_prefix + data.team_id;
  //   }
  //   if (id === team_id){
  //     XMPP.getFileLinksSaveMessages({
  //       offset: offset, limit: limit, action: "get_details_for_group",
  //       details_for_group: "files", peer_id: id
  //     });
  //   }
  //   else{
  //     XMPP.getFileLinksSaveMessages({
  //       offset: 0, limit: limit,  action: "get_details_for_user",
  //       details_for_user: "files", peer_id: id && id.toString()
  //     });
  //   }

  //   store.dispatch({
  //     type: Types.CONTACT_FILE_LOAD,
  //     payload: {
  //       isfileLoad:true,
  //       contactfileLength:contactfileLength,
  //       isfileStopPagination:isfileStopPagination
  //     }
  //   });


  // }
  public static async createContactTask(formData: any) {

    let loginUser: any = store.getState().loginReducer.userdetails;
    let { chatWindowDetails }: any = store.getState().chatWindowReducer;
    let contactDetails: any = formData?.key === "login" ? loginUser : chatWindowDetails;
    let data: any = {
      "summary": formData?.summary ? formData?.summary : formData?.taskName,
      "description": formData?.description,
      "duration": "",
      "priority": "Medium",
      "reporterStatus": "",
      "creatorStatus": "In progress",
      "taskStatus": "",
      "percentage": 0,
      "lastUpdatedBy": "",
      "completedStatus": "",
      "attachments": [
      ],
      "attendee": formData?.attendee ? formData?.attendee : formData?.assigneeArray,
      "dtstart": formData?.dueDate ? (new Date(formData?.dueDate).getTime() / 1000).toFixed(0) : "",
      "dtend": formData?.dtend ? formData?.dtend : formData?.dueDate ? (new Date(formData?.dueDate).getTime() / 1000).toFixed(0) : "",
      "action": "",
      "trigger": "",
      "status": false,
      sender: loginUser?.sip_login_id,
      receiver: Object.keys(contactDetails).length > 0 ? 'team_id' in contactDetails ?
        contactDetails?.team_id :
        contactDetails?.sip_login_id?.toString() : loginUser?.sip_login_id,
      groupId: contactDetails &&
      'team_id' in contactDetails ? contactDetails?.team_id : "",
      "threadId": "",
      "dueTime": "",
      "rrule": "",
      "recurOptions": "None",
      "stopRecur": "",
      "reportTo": [
      ],
      "replaceId":"",
      "domainId": loginUser?.domain_id

    };

    new eventService().createTask(data)
      .then((res: any) => {

        if (res.statusCode === 200) {

          store.dispatch({
            type: Types.CONTACT_TASK_UPDATE,
            payload: {
              isTaskUpdate: true
            }
          });
          toastInformation(config().TASKSUCCESS, 'success');
          contactService.taskViewToast(true, res, formData?.key);
        }
        else {
          toastInformation(config().APIFAILURE, 'success');
        }

      }).catch((error: any) => {

        console.log(error, 'error');

      });

  }


  public static async editContactTask(taskData: any, key: any, fullTaskData?:any) {
    // let { chatWindowDetails }: any = store.getState().chatWindowReducer;
    // let { contactWindowDetails }: any = store.getState().contactWindowReducer;
    // let contactDetial: any = key ? contactWindowDetails : chatWindowDetails;
    let loginUser: any = store.getState().loginReducer.userdetails || [];
    var currentdate = (new Date().getTime() / 1000).toFixed(0);
    let data: any = {
      "summary": taskData?.name,
      "description": taskData?.description,
      "duration": "",
      "priority": taskData?.taskPriority,
      "reporterStatus": "",
      "creatorStatus": "In progress",
      "taskStatus": taskData?.taskStatus,
      "percentage": taskData?.taskPercentage,
      "lastUpdatedBy": "",
      "completedStatus": "",
      "attachments": taskData?.attachmentArray,
      "attendee": taskData?.attendee,
      "dtstart": taskData?.dtstart && taskData?.dtstart !=="NaN" ? taskData?.dtstart :currentdate,
      "dtend": taskData?.dtend && taskData?.dtend !=="NaN" ? taskData?.dtend: currentdate,
      "action": "",
      "trigger": "",
      "status": false,
      "sender": fullTaskData?.sender,
      "receiver":  fullTaskData?.receiver,
      "groupId": fullTaskData?.groupId,
      "threadId": taskData?.thread_id,
      "dueTime": "",
      "rrule": taskData?.rruleValue,
      "recurOptions":taskData?.rruleValue ? taskData?.recurrence : "None",
      "stopRecur": "",
      "reportTo": taskData?.reportTo,
      "replaceId": taskData?.replace_id,
      "domainId": loginUser?.domain_id
    };

    new eventService().editTask(taskData?.uid, data)
      .then((res: any) => {

        if (res.statusCode === 200) {
          store.dispatch({
            type: Types.CONTACT_TASK_UPDATE,
            payload: {
              isTaskUpdate: true
            }
          });
          toastInformation(config().TASKEDIT, 'success');
        }else {
          toastInformation(config().APIFAILURE, 'success');
        }

      }).catch((error: any) => {
        console.log(error, 'error');
      });
  }

  public static async completedTask(taskData: any, key: any) {
    let { chatWindowDetails }: any = store.getState().chatWindowReducer;
    let { contactWindowDetails }: any = store.getState().contactWindowReducer;
    let contactDetial: any = key ? contactWindowDetails : chatWindowDetails;
    let loginUser: any = store.getState().loginReducer.userdetails || [];
    
    let data: any = {
      "priority": taskData?.taskPriority,
      "taskStatus": taskData?.taskStatus,
      "percentage": taskData?.taskPercentage,
      "lastUpdatedBy": 'team_id' in contactDetial ?
        contactDetial?.team_id : contactDetial?.sip_login_id?.toString(),
      "domainId": loginUser?.domain_id
    };

    new eventService().completeTask(taskData?.uid, data)
      .then((res: any) => {
        store.dispatch({
          type: Types.CONTACT_TASK_UPDATE,
          payload: {
            isTaskUpdate: true
          }
        });
        console.log(res, 'res');
      }).catch((error: any) => {
        console.log(error, 'error');
      });
  }
  public static async deleteContactTask(data: any) {

    let loginUser: any = store.getState().loginReducer.userdetails;
    let taskData = {
      uid: data.uid,
      domainId: loginUser.domain_id
    };
    return new eventService().deleteTask(taskData)
      .then((res: any) => {
        if (res.statusCode === 200) {
          store.dispatch({
            type: Types.CONTACT_TASK_UPDATE,
            payload: {
              isTaskUpdate: true
            }
          });
          toastInformation(config().TASKDELETE, 'success');
        }

      }).catch((error: any) => {
        console.log(error, 'error');

      });

  }

  public static async contactSideWindow(isOpen: boolean, isKey: string, editdata: any) {

    store.dispatch({
      type: Types.CONTACT_WINDOW_SLIDE_OPEN,
      payload: {
        isWindowSlide: isOpen,
        isKey: isKey,
        editData: editdata
      }
    });
  }

  public static async taskViewToast(Type: boolean, res: any, location: any) {


    store.dispatch({
      type: Types.VIEW_EVENTS_FROM_TOAST,
      payload: {
        isEventviewontoast: false,
        Eventviewontoast: {},
        isTaskviewontoast: Type,
        Taskviewontoast: res,
        isNotesviewontoast: false,
        notesviewontoast: {},
        isViewbutton: location === "login" ? true : false
      }
    });
    setTimeout(function () {
      store.dispatch({
        type: Types.VIEW_EVENTS_FROM_TOAST,
        payload: {
          isEventviewontoast: false,
          Eventviewontoast: {},
          isTaskviewontoast: false,
          Taskviewontoast: {},
          isNotesviewontoast: false,
          notesviewontoast: {}
        }
      });
    }, 5000);

  }
  public static async notesViewToast(Type: boolean, res: any, location: any) {
    store.dispatch({
      type: Types.VIEW_EVENTS_FROM_TOAST,
      payload: {
        isEventviewontoast: false,
        Eventviewontoast: {},
        isTaskviewontoast: false,
        Taskviewontoast: {},
        isNotesviewontoast: Type,
        notesviewontoast: res,
        isViewbutton: location === "login" ? true : false
      }
    });
    setTimeout(function () {
      store.dispatch({
        type: Types.VIEW_EVENTS_FROM_TOAST,
        payload: {
          isEventviewontoast: false,
          Eventviewontoast: {},
          isTaskviewontoast: false,
          Taskviewontoast: {},
          isNotesviewontoast: false,
          notesviewontoast: {}
        }
      });
    }, 5000);

  }
}
